export const getFirmaRegistrationNumber = (firma: {
  cvrNr?: number | null;
  udenlandskVirksomhedsId?: string | null;
}) => firma.cvrNr ?? firma.udenlandskVirksomhedsId ?? null;

export const hasFirmaRegistrationNumber = (firma: {
  cvrNr?: number | null;
  udenlandskVirksomhedsId?: string | null;
}) => !!getFirmaRegistrationNumber(firma);

export const isEuVatRegistrationNumber = (firma: {
  cvrNr?: number | null;
  udenlandskVirksomhedsId?: string | null;
}) => !firma.cvrNr && !!firma.udenlandskVirksomhedsId;

export const getFirmaRegistrationNumberLabel = (firma: {
  cvrNr?: number | null;
  udenlandskVirksomhedsId?: string | null;
}) => (isEuVatRegistrationNumber(firma) ? "VAT-nr." : "CVR-nr.");
